import { HouseColumn, HouseOccupantColumn } from "../interfaces";

export const columnsConstants = {
    houseOccupantDefaultColumns: [
        {
            id: "name",
            name: "Name",
            selected: true,
            type: null,
            disabled: true,
        } as HouseOccupantColumn,
        {
            id: "address",
            name: "Address",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "hovoterid",
            name: "Contact ID",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "hoemail",
            name: "Email",
            hokey: "email",
            selected: true,
            type: "email",
        } as HouseOccupantColumn,
        {
            id: "hohomephone",
            name: "Home Phone",
            hokey: "homephone",
            selected: true,
            type: "phone",
        } as HouseOccupantColumn,
        {
            id: "homobilephone",
            name: "Mobile Phone",
            hokey: "mobilephone",
            selected: true,
            type: "phone",
        } as HouseOccupantColumn,
        {
            id: "hogender",
            name: "Gender",
            hokey: "gender",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "hoage",
            name: "Age",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "hodob",
            name: "Date of Birth",
            hokey: "dob",
            selected: true,
            type: "date",
        } as HouseOccupantColumn,
        {
            id: "hoparty",
            name: "Organization",
            hokey: "party",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "esname",
            name: "Employment",
            hokey: "employment",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "hovolunteer",
            name: "Volunteer",
            hokey: "volunteer",
            selected: true,
            type: "bool",
        } as HouseOccupantColumn,
        {
            id: "hodeceased",
            name: "Deceased",
            hokey: "deceased",
            selected: true,
            type: "bool",
        } as HouseOccupantColumn,
        {
            id: "hodonor",
            name: "Donor",
            hokey: "donor",
            selected: true,
            type: "bool",
        } as HouseOccupantColumn,
        {
            id: "cscreationdatetime",
            name: "Last Interacted With",
            selected: true,
            type: "timeago",
        } as HouseOccupantColumn,
        {
            id: "csreception",
            name: "Last Rating",
            selected: true,
            type: "rating",
        } as HouseOccupantColumn,
        {
            id: "cssname",
            name: "Last Interaction Status",
            selected: true,
            type: "canvassstatus",
        } as HouseOccupantColumn,
        {
            id: "user",
            name: "Last Interaction Performed By",
            selected: true,
            type: "user",
        } as HouseOccupantColumn,
        {
            id: "cstype",
            name: "Last Interaction App Type",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "signature",
            name: "Signature",
            selected: true,
            type: "signature",
        } as HouseOccupantColumn,
        {
            id: "income",
            name: "Income",
            hokey: "income",
            selected: true,
            type: "number",
        } as HouseOccupantColumn,
        {
            id: "credit_rating",
            name: "Credit Rating",
            hokey: "credit_rating",
            selected: true,
            type: null,
        } as HouseOccupantColumn,
        {
            id: "donor_environmental",
            name: "Interested in Green Living",
            hokey: "donor_environmental",
            selected: true,
            type: "bool",
        } as HouseOccupantColumn,
    ],
    houseDefaultColumns: [
        {
            id: "hnumber",
            name: "Number",
            selected: true,
            type: null,
            disabled: true,
        } as HouseColumn,
        {
            id: "haddress",
            name: "Street",
            selected: true,
            type: null,
            disabled: true,
        } as HouseColumn,
        {
            id: "hcity",
            name: "City",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hstate",
            name: "State",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hunit",
            name: "Unit",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hfloor",
            name: "Floor",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hname",
            name: "Name",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hzipcode",
            name: "Zip Code",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hdirections",
            name: "Directions",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hprecinct",
            name: "Precinct",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "location",
            name: "Lat/Lng",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hcreationdatetime",
            name: "Created",
            selected: true,
            type: "timeago",
        } as HouseColumn,
        {
            id: "notes",
            name: "Notes",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "cscreationdatetime",
            name: "Last Interacted With",
            selected: true,
            type: "timeago",
        } as HouseColumn,
        {
            id: "csreception",
            name: "Last Rating",
            selected: true,
            type: "rating",
        } as HouseColumn,
        {
            id: "cssname",
            name: "Last Interaction Status",
            selected: true,
            type: "canvassstatus",
        } as HouseColumn,
        {
            id: "user",
            name: "Last Interaction Performed By",
            selected: true,
            type: "user",
        } as HouseColumn,
        {
            id: "cstype",
            name: "Last Interaction App Type",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "hlocationtype",
            name: "Geocode Location Type",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "dwelling_type",
            name: "Dwelling Type",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "homeowner",
            name: "Homeowner",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "square_footage",
            name: "Square Footage",
            selected: true,
            type: "number",
        } as HouseColumn,
        {
            id: "year_built",
            name: "Year Built",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "purchase_price",
            name: "Purchase Price",
            selected: true,
            type: "number",
        } as HouseColumn,
        {
            id: "purchase_year",
            name: "Purchase Year",
            selected: true,
            type: null,
        } as HouseColumn,
        {
            id: "net_worth",
            name: "Household Net Worth",
            selected: true,
            type: null,
        } as HouseColumn,
    ],
} as const;
